/* eslint-disable @typescript-eslint/no-explicit-any */
import { SortConfig } from '@Features/types/SortConfig';
import { SorterResult } from 'antd/es/table/interface';

type Orders = {
  ascend: 'asc';
  descend: 'desc';
};

const orderMap: Orders = {
  ascend: 'asc',
  descend: 'desc',
};

export const prepareSortConfig = (
  rawSortConfig: SorterResult<any> | SorterResult<any>[]
): SortConfig | null => {
  if (Array.isArray(rawSortConfig)) {
    // not sure yet in which cases Sorter config may be array
    return null;
  }

  const { order, columnKey } = rawSortConfig;

  const sortBy = String(columnKey);
  const sortOrder = order ? orderMap[order] : undefined;

  const output: SortConfig = {
    sortBy,
    sortOrder,
  };
  return output;
};

export const mapToCustomPageIndex = (defaultPageIndex: number): number => {
  return defaultPageIndex + 1;
};

export const mapToDefaultPageIndex = (customPageIndex: number): number => {
  return customPageIndex - 1;
};
